import { ApprovalProcessConfigViewModel } from '@ail/orders-api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../../hooks/useAuth'
import { useGetApproverEmailsQuery } from '../../../../redux/api/ordersApi'
import './ApprovalProcessConfigSteps.scss'
export function ApprovalProcessConfigSteps(props: {
  approvalProcessConfig: ApprovalProcessConfigViewModel
  formId: string
}) {
  const { t } = useTranslation('common')
  const { user } = useAuth()
  const approvers = useGetApproverEmailsQuery(props.formId, { skip: !user?.isInternalUser || !props.formId })

  const stepsWithApprovers = useMemo(() => {
    if (props.approvalProcessConfig.steps?.length) {
      return props.approvalProcessConfig.steps.map((s) => {
        const stepApprovers =
          approvers.currentData
            ?.filter((a) => s.owners?.some((o) => o === a.id || a.customers.includes(o) || a.units.includes(o)))
            .map((a) => a.email) ?? []
        return [s.stepNumber, stepApprovers.join(', '), s.autoApprove]
      })
    } else if (props.approvalProcessConfig.stepsWithTags?.length) {
      return props.approvalProcessConfig.stepsWithTags.map((s) => {
        const stepApprovers =
          approvers.currentData?.filter((a) => s.tags?.some((t) => a.tags.includes(t))).map((a) => a.email) ?? []
        return [s.number, stepApprovers.join(', '), s.autoApprove]
      })
    }
    return []
  }, [approvers.currentData, props.approvalProcessConfig.steps, props.approvalProcessConfig.stepsWithTags])

  return (
    <table className="approval-process-config-steps">
      <thead>
        <tr>
          <th className="ApproveStep">{t('STEP')}</th>
          <th className="ApproveUser">{t('USERS')}</th>
        </tr>
      </thead>
      <tbody>
        {stepsWithApprovers.map((row, index) => (
          <tr key={index}>
            <td className={row[2] ? 'ApproveStep Auto' : 'ApproveStep'}>{row[0]}</td>
            <td>{row[1]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
